import React from "react";
import { useLang } from "../i18n/LanguageContext";
import Seo from "../components/Seo";
import { At, Phone, MapPin } from "@phosphor-icons/react";

const COPY = {
  cs: {
    eyebrow: "Kontakt",
    title: "Pojďme se potkat.",
    lead:
      "Připravíme nezávaznou nabídku na realizaci vašich retailových projektů v námi nabízených činnostech. Reálná čísla a doporučení — žádné prezentace.",
    sections: {
      reach: "Spojte se s námi",
      visit: "Navštivte nás",
    },
    company: "Global Marketing s.r.o.",
    address: "Praha · Bratislava",
  },
  en: {
    eyebrow: "Contact",
    title: "Let's meet.",
    lead:
      "We'll prepare a non-binding estimate for your specific scope — chains, store count, visit frequency. Real numbers, no slideware.",
    sections: {
      reach: "Reach us",
      visit: "Visit us",
    },
    company: "Global Marketing s.r.o.",
    address: "Prague · Bratislava",
  },
  sk: {
    eyebrow: "Kontakt",
    title: "Poďme sa stretnúť.",
    lead:
      "Pripravíme nezáväznú ponuku na realizáciu vašich retailových projektov v nami ponúkaných činnostiach. Reálne čísla a odporúčania — žiadne prezentácie.",
    sections: {
      reach: "Spojte sa s nami",
      visit: "Navštívte nás",
    },
    company: "Global Marketing s.r.o.",
    address: "Praha · Bratislava",
  },
};

export default function Kontakt() {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.cs;
  return (
    <div data-testid="kontakt-page">
      <Seo
        title={{ cs: "Kontakt", en: "Contact" }}
        description={{
          cs:
            "Pojďme se potkat. Připravíme nezávaznou nabídku na realizaci vašich retailových projektů v námi nabízených činnostech.",
          en:
            "Let's meet. Non-binding proposal for the retail projects within our service scope.",
        }}
        path="/kontakt"
      />
      <section className="relative bg-white border-b border-[#e5e5e5]">
        <div className="absolute inset-0 gm-grid-bg pointer-events-none" />
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-14 md:pb-20 relative">
          <span className="gm-eyebrow text-[#0A4DFF]">{c.eyebrow}</span>
          <h1 className="font-display text-5xl md:text-7xl tracking-tighter font-medium leading-[0.95] mt-6 max-w-4xl">
            {c.title}
          </h1>
          <p className="text-lg md:text-xl text-[#525252] mt-8 max-w-3xl leading-relaxed">{c.lead}</p>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-[#fafafa]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-6">
            <span className="gm-eyebrow">// {c.sections.reach}</span>
            <ul className="mt-6 border-t-2 border-[#0a0a0a]">
              <li className="py-5 flex items-center gap-4 border-b border-[#e5e5e5]">
                <At size={20} weight="thin" className="text-[#0A4DFF] shrink-0" />
                <a href="mailto:info@globalmarketing.cz" className="font-display text-xl md:text-2xl hover:text-[#0A4DFF] transition-colors break-all" data-testid="contact-email">
                  info@globalmarketing.cz
                </a>
              </li>
              <li className="py-5 flex items-center gap-4 border-b border-[#e5e5e5]">
                <Phone size={20} weight="thin" className="text-[#0A4DFF] shrink-0" />
                <a href="tel:+420602111108" className="font-display text-xl md:text-2xl hover:text-[#0A4DFF] transition-colors" data-testid="contact-phone">
                  +420 602 111 108
                </a>
              </li>
            </ul>
          </div>
          <div className="md:col-span-6">
            <span className="gm-eyebrow">// {c.sections.visit}</span>
            <ul className="mt-6 border-t-2 border-[#0a0a0a]">
              <li className="py-5 flex items-start gap-4 border-b border-[#e5e5e5]" data-testid="contact-address">
                <MapPin size={20} weight="thin" className="text-[#0A4DFF] shrink-0 mt-1.5" />
                <div>
                  <div className="font-display text-xl md:text-2xl">{c.company}</div>
                  <div className="text-[#525252] mt-2 leading-relaxed">{c.address}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
